import { createRequestTypes } from 'common/websocket-redux';

export const GET_USER_SETTINGS = createRequestTypes('user/GET_USER_SETTINGS');
